import { notify } from '@kyvg/vue3-notification'
import router from '@/router'
import i18n from '@/i18n'
import { useTariffStore } from '@/store/tariffStore'
import {
    TARIFF_GATE_REASON_CODES as REASONS,
    TARIFF_SUBJECT_MODES as SUBJECT_MODES,
    isQuizOwnedFeatureKey,
} from '@/constants/tariffFeatureKeys'

export function useTariffUpgrade() {
    return {
        // context: { featureKey, requiredValue, source, quizId, action, reasonCode }
        openUpgrade(context = {}) {
            const t = i18n.global.t

            if (context?.reasonCode === REASONS.COLLABORATION_PERMISSION_DENIED) {
                notify({ title: t('tariffGateCollaborationForbiddenMessage'), type: 'warn' })
                return
            }

            if (isQuizOwnedFeatureKey(context?.featureKey)) {
                const { mode } = useTariffStore().resolveTariffSubject(context.featureKey)

                if (mode === SUBJECT_MODES.PENDING) {
                    return
                }
                // Buying a plan would not help a collaborator: quiz.* features
                // follow the quiz owner's tariff.
                if (mode === SUBJECT_MODES.OWNER) {
                    notify({ title: t('tariffOwnerPlanFeatureUnavailableMessage'), type: 'warn' })
                    return
                }
                if (mode === SUBJECT_MODES.OWNER_UNAVAILABLE) {
                    notify({ title: t('tariffOwnerAccessUnavailableMessage'), type: 'warn' })
                    return
                }
            }

            if (router.currentRoute.value.path !== '/tariffs') {
                router.push('/tariffs')
            }
        },
    }
}
